<template>
    
    <div class="cc-alert" :class="alertType" v-if="message && alertType">
        {{ message }}
    </div>

</template>

<script>

export default {
    name: 'ccAlert',

    data () {
        return {
            alertType: 'error'
        }
    },

    props: {

        message: {
            type: String,
            default: null
        },

        type: {
            type: String,
            default: 'error'
        },

    },

    created() {
        this.alertType = "cc-alert--"+this.type ;
    }

}

</script>